import { ICaseLawDocumentService } from "../service/CaseLawDocumentService";

export default class PublishCaseLawDocumentInteractor {
  private caseLawDocumentService: ICaseLawDocumentService;

  constructor({ caseLawDocumentService }: any) {
    this.caseLawDocumentService = caseLawDocumentService;
  }

  async execute(caseLawDocumentId: number) {
    return this.caseLawDocumentService.publishCaseLawDocument(
      caseLawDocumentId
    );
  }
}
